import {
  ComponentCmsDataHeaderSection,
  useMainLayoutPageQuery,
} from "@/generated";

export const useMainLayout = () => {
  const { data } = useMainLayoutPageQuery({
    variables: {
      filters: {
        slug: {
          eq: "main-layout",
        },
      },
    },
  });

  const headerDataSection = data?.pages?.data?.[0]?.attributes
    ?.components?.[0] as ComponentCmsDataHeaderSection;

  return {
    image: {
      url: headerDataSection?.image?.data?.attributes?.url || "",
      altTag: headerDataSection?.image?.data?.attributes?.alternativeText || "",
    },
    ...(headerDataSection?.button && {
      button: {
        text: headerDataSection?.button?.text,
        url: headerDataSection?.button?.url,
      },
    }),
    ...(headerDataSection?.helloBarContent && {
      helloBarContent: headerDataSection?.helloBarContent,
    }),
  };
};
